import resizeImage from '@/helpers/imageResizeHelper'
import getApiClient from '@/plugins/api-client'

export default {
    selectProfilePicture: function() {
        this.$refs['profilePicture'].click()
    },

    startImageCropping: function(event) {
        const self = this

        let input = event.target;
        if (input.files && input.files[0]) {
            let reader = new FileReader();
            reader.onload = async (e) => {
                let totalMb = e.total / 1000000
                if (totalMb > 10) {
                    self.error = 'A nova imagem de perfil não pode ter mais de 10MB. Escolha uma imagem menor.'
                    self.showErrorDialog = true
                    return
                }
                self.user.photo = await resizeImage(e.target.result)
                self.openCropper(self.user.photo)
            };
            reader.readAsDataURL(input.files[0]);
        }
    },

    openCropper: function (photo) {
        const self = this

        self.showCropper = true
        self.croppingImage = photo
    },

    setPhoto: function() {
        const self = this,
            api = getApiClient(self.$store),
            userId = self.$store.state.session.user.id

        self.showCropper = false
        const { canvas } = self.$refs.photoCropper.getResult();
        self.user.photo = canvas.toDataURL('image/jpeg', 70)

        api.patch(`profile_picture/${userId}`, self.user, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.$store.commit('updateUserProfilePicture', result?.data?.photo_images)
                self.user.photo_images = result?.data?.photo_images
            })
            .catch(error => {
                console.log(error)
            })
    }
}
